import { useI18n } from "i18n";
import { useState } from "react";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { FormControlLabel } from "@remo-co/ui-core/src/components/FormControlLabel";
import { Checkbox } from "@remo-co/ui-core/src/components/Checkbox";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { MusicNote } from "@remo-co/ui-core/src/icons/MusicNote";
import { MusicOff } from "@remo-co/ui-core/src/icons/MusicOff";
import { SoundWavesAnimation } from "modules/svgMapView/templateParts/SoundWavesAnimation";
import { useStyles } from "./styles";

const LobbyMusic = require("modules/lobby/assets/lobby.mp3");

interface Props {
  message?: string;
  autoJoinDisabled: boolean;
  autoJoin: boolean;
  toggleAutoJoin: () => void;
}
export const LobbyControls = ({
  message,
  autoJoinDisabled,
  autoJoin,
  toggleAutoJoin,
}: Props): JSX.Element => {
  const { t } = useI18n(["common", "micCamCheck"]);
  const [lobbyMusicMuted, setLobbyMusicMuted] = useState(false);
  const styles = useStyles();

  const toggleLobbyMusic = () => {
    setLobbyMusicMuted(!lobbyMusicMuted);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginTop={4}
    >
      {message ? (
        <Typography align="center" variant="subtitle1">
          {message}
        </Typography>
      ) : (
        <Typography align="center" variant="h4">
          {t("common:please.wait.host")}
        </Typography>
      )}
      <Box display="flex" alignItems="center" marginTop={3}>
        <FormControlLabel
          disabled={autoJoinDisabled}
          classes={{
            root: styles.controlLabelRoot,
          }}
          control={
            <Checkbox
              classes={{ root: styles.checkBox }}
              onChange={toggleAutoJoin}
              color="primary"
            />
          }
          label={t("micCamCheck:auto.join.on.admission")}
        />
        {autoJoin && (
          <>
            <Button onClick={toggleLobbyMusic} isIconButton variant="ghost">
              <Typography variant="subtitle2">
                <Box display="flex" alignItems="center">
                  {lobbyMusicMuted ? (
                    <MusicOff />
                  ) : (
                    <>
                      <MusicNote />
                      <div className={styles.soundWaves}>
                        <SoundWavesAnimation />
                      </div>
                    </>
                  )}
                </Box>
              </Typography>
            </Button>
            <audio loop autoPlay muted={lobbyMusicMuted}>
              <source src={LobbyMusic} type="audio/mpeg" />
            </audio>
          </>
        )}
      </Box>
    </Box>
  );
};
